import styled from 'styled-components';

const Submit = styled.div`
  width: 100%;
  margin-top: 38px;
`;

export default Submit;
